import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import { TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment } from 'generated/graphql'
import { ExamContext } from '@app.feature/exam/context/ExamContext'
import { ANSWER_NUMVER_MAP } from '@app.feature/exam/gsat2024-2/constants/answerNumberMap'
import { TentativeScoringQuestionContext } from '@app.feature/exam/gsat2024-2/context/TentativeScoringQuestionContext'
import AnswerRadioButtonGroup from '@app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/components/radio/AnswerRadioButtonGroup'
import { TentativeScoringQuestionListFormType } from '@app.feature/exam/gsat2024-2/types/tentativeScoringQuestionListForm.type'

interface TentativeScoringQuestionItemMobileProps {
  questionData: TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment
}

const TentativeScoringQuestionItemMobile = ({
  questionData,
}: TentativeScoringQuestionItemMobileProps) => {
  const { handleCheckReservation } = useContext(ExamContext)
  const { subject } = useContext(TentativeScoringQuestionContext)
  const { setValue, register, resetField } =
    useFormContext<TentativeScoringQuestionListFormType>()

  const predictionAnswer = ANSWER_NUMVER_MAP[questionData.answers[0] - 1]

  const handleChangeAnswer = () => {
    handleCheckReservation({
      onReservated: () => {
        setValue(
          `${subject}.inputQuestions.${questionData.seq - 1}.questionId`,
          questionData.id,
        )
      },
      onNotReservated: () => {
        resetField(`${subject}.inputQuestions.${questionData.seq - 1}`)
      },
    })
  }

  return (
    <StyledWrapper>
      <p className="question-number">{questionData.seq}번 문항</p>
      <div className="prediction-answer-box">
        <p>{questionData.content}</p>
        <p>가답안 {predictionAnswer}번</p>
      </div>
      <div className="choice-answer-box">
        <p className="selected-answer-text">내가 고른답</p>
        <AnswerRadioButtonGroup
          id={`tentative-scoring-${subject}-question-${questionData.seq}`}
          {...register(
            `${subject}.inputQuestions.${questionData.seq - 1}.selectedAnswer`,
            {
              onChange: handleChangeAnswer,
            },
          )}
        />
      </div>
    </StyledWrapper>
  )
}

export default TentativeScoringQuestionItemMobile

const StyledWrapper = styled.li`
  width: 100%;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #eeeeee;

  > .question-number {
    font-size: 15px;
    font-weight: normal;
    letter-spacing: -0.6px;
    text-align: left;
    color: #333;
  }

  > .prediction-answer-box {
    display: flex;
    align-items: center;
    column-gap: 24px;
    row-gap: 10px;
    margin-top: 16px;
    flex-wrap: wrap;

    > p {
      font-size: 15px;
      font-weight: normal;
      letter-spacing: -0.6px;
      text-align: left;
      color: #333;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      overflow-wrap: break-word;
    }
  }

  > .choice-answer-box {
    display: flex;
    align-items: center;
    gap: 21px;
    margin-top: 10px;

    > .selected-answer-text {
      font-size: 15px;
      font-weight: normal;
      letter-spacing: -0.6px;
      text-align: left;
      color: #333;
    }
  }
`
